import React, { useEffect, useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import {
  getAppId,
  getEmail,
  getStageID,
  getTravelInfo,
  setTStageID,
} from "../utility/Common";
import Header from "./layout/Header";
import NavBar_appID from "./layout/NavBar_appID";
import Footer from "./layout/Footer";
import "react-phone-input-2/lib/bootstrap.css";
import { createNotification } from "./Popup";
import { applicationManagement } from "../utility/services/apiService";
import { messages } from "../utility/services/message";
import { getResource } from "../utility/services/resources";
import DeclarationReusableComponent from "./declarationReusableComponent";
import CentryReusableComponent from "./CentryReusableComponent";
import { travelInfo } from "../formValidation/FormValidator";

function HabariZaSafari({ applicationReuserbleManagement }) {
  let navigate = useNavigate();
  let uselocationData = useLocation()?.state;

  const [TravelPurposeID, setTravelPurposeID] = useState("");
  const [VisitCountryID, setVisitCountryID] = useState("");
  const [isloading, setIsloading] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [countries, setCountries] = useState([]);
  const [visitPurpose, setVistiPurpos] = useState([]);
  const [ocupations, setOcupations] = useState([]);
  const [occupatinID, setOccupationID] = useState([]);
  const [stageId, setStageId] = useState();
  const { checkApplicationStage } = CentryReusableComponent({});
  const { isLoading, handleApplicationManagement } =
    DeclarationReusableComponent({
      applicationManagement,
    });
  const [errors, setErrors] = useState({});
  useEffect(() => {
    fetchPurpos();
    setTravelInfo();
  }, []);

  const fetchCountries = async () => {
    const result = await getResource("VisitName", getAppId(), "null", "lookup");
    if (Array.isArray(result) && result.length > 0) {
      setCountries(result);
      fetchOcupations();
    } else {
      setCountries([]);
    }
  };

  const fetchPurpos = async () => {
    const result = await getResource("Purpose", "null", "null", "lookup");
    if (Array.isArray(result) && result?.length > 0) {
      setVistiPurpos(result);
      fetchCountries();
    } else {
      setVistiPurpos([]);
    }
  };

  const fetchOcupations = async () => {
    const result = await getResource("Occupation", "null", "null", "lookup");
    if (Array.isArray(result) && result?.length > 0) {
      setOcupations(result);
    } else {
      setOcupations([]);
    }
  };
  const setTravelInfo = () => {
    checkApplicationStage(1);
    const data = getTravelInfo();
    setStageId(data?.DocStageID);
    setTravelPurposeID(data?.TravellingPurpose);
    setVisitCountryID(data?.CountryID);
    setOccupationID(data?.CountryID);
  };

  const getAddresInfo = () => {
    setIsFetching(true);
    const payload = {
      Action: "Select",
      ResidenceDistrictID: "",
      ResidenceVillage: "",
      HouseNumber: "",
      ApplicationId: getAppId(),
      EmailAddress: getEmail(),
    };
    handleApplicationManagement(payload, "add-address-info");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsloading(true);

    if (getStageID() == 110) {
      const step_four = {
        Action: "Insert",
        ApplicationId: getAppId(),
        TravellingPurposeID: TravelPurposeID,
        CountryID: VisitCountryID,
        OccupationID: occupatinID,
        EmailAddress: getEmail(),
      };
      const newErrors = travelInfo(step_four);
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
      } else {
        setErrors({});
        setIsloading(true);

        applicationManagement(step_four, "add-travel-info").then(
          (result) => {
            setIsloading(false);
            if (result.code == 1) {
              console.log(result.data, "habari za safari");
              if (result.data[0]?.code == 1) {
                if (result.data) {
                  handleApplicationManagement("", "declaration");
                  const stID = result.data[0]?.DocStageID;
                  setTStageID(stID);
                }
                handleApplicationManagement("", "declaration");
              } else {
                setIsloading(false);
                const info = { type: "error", message: result?.message };
                createNotification(info)();
              }
            } else {
              setIsloading(false);
              const info = { type: "error", message: result.message };
              createNotification(info)();
            }
          },
          (error) => {
            setIsloading(false);
            const info = { type: "error", message: messages.networkError };
            createNotification(info)();
          },
        );
      }
    } else {
      const step_four = {
        Action: "Update",
        ApplicationId: getAppId(),
        TravellingPurposeID: TravelPurposeID,
        CountryID: VisitCountryID,
        OccupationID: occupatinID,
        EmailAddress: getEmail(),
      };

      const newErrors = travelInfo(step_four);
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
      } else {
        setErrors({});
        setIsloading(true);
        applicationManagement(step_four, "add-travel-info").then(
          (result) => {
            if (result.code == 1) {
              if (result.data[0]?.code == 1) {
                if (result.data) {
                  const stID = result.data[0]?.DocStageID;
                  setTStageID(stID);
                }
                handleApplicationManagement("", "declaration");
              } else {
                setIsloading(false);
                const info = { type: "error", message: result?.message };
                createNotification(info)();
              }
            } else {
              setIsloading(false);
              const info = { type: "error", message: result.message };
              createNotification(info)();
            }
          },
          (error) => {
            setIsloading(false);
            const info = { type: "error", message: messages.networkError };
            createNotification(info)();
          },
        );
      }
    }
  };
  const endeleaBadae = () => {
    navigate("/");
  };
  return (
    <>
      <Header />
      <div className="container">
        <NavBar_appID />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12 module-content2">
            <div
              className="col-md-12 col-sm-12 col-xs-12 tab-registration-container"
              style={{ marginTop: "-5px" }}
            >
              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 tab-registration-menu hidden-xs">
                <div className="list-group">
                  <Link className="list-group-item done">Habari Binafsi </Link>
                  <Link
                    onClick={getAddresInfo}
                    className="list-group-item done"
                  >
                    Anuwani ya Makazi
                  </Link>
                  <Link className="list-group-item done">Habari za Wazazi</Link>
                  <Link className="list-group-item active">
                    Habari za Safari
                  </Link>
                  <Link className="list-group-item ">Wakati wa Dharura</Link>
                  <Link className="list-group-item ">Viambatanisho </Link>
                  <Link className="list-group-item ">Tamko Rasmi </Link>
                  <Link className="list-group-item ">Kamilika </Link>
                </div>
              </div>
              <div
                className="col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-registration-tab"
                style={{ marginTop: "1px", paddingRight: "1px" }}
              >
                <div className="tab-registration-content active">
                  <form id="step-four-form" onSubmit={handleSubmit}>
                    <div className="box box-default">
                      <div className="box-header with-border">
                        <h3 className="box-title">Madhumuni ya Safari</h3>
                      </div>
                      <div className="box-body" style={{ display: "block" }}>
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group field-passporttravelandguardian-travelpurposeid required">
                              <label
                                className="control-label"
                                htmlFor="passporttravelandguardian-travelpurposeid"
                              >
                                Dhumuni la Safari
                              </label>
                              <select
                                id="TravelPurposeID"
                                className="form-control"
                                name="TravelPurposeID"
                                onChange={(e) =>
                                  setTravelPurposeID(e.target.value)
                                }
                                value={TravelPurposeID}
                                required
                              >
                                <option value="">
                                  Chagua Dhumuni la Safari
                                </option>
                                {visitPurpose?.length > 0 &&
                                  visitPurpose?.map((purpose) => (
                                    <option
                                      key={purpose?.id}
                                      value={purpose?.ResourceID}
                                    >
                                      {purpose?.ResourceName}
                                    </option>
                                  ))}
                              </select>
                              <p className="help-block help-block-error"></p>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group field-passporttravelandguardian-visitcountryid required">
                              <label
                                className="control-label"
                                htmlFor="passporttravelandguardian-visitcountryid"
                              >
                                Nchi Unayokwenda
                              </label>
                              <select
                                id="VisitCountryID"
                                className="form-control"
                                name="VisitCountryID"
                                onChange={(e) =>
                                  setVisitCountryID(e.target.value)
                                }
                                value={VisitCountryID}
                                required
                              >
                                <option value="">
                                  Chagua Nchi Unayokwenda
                                </option>
                                {countries.length > 0 &&
                                  countries?.map((doc) => (
                                    <option key={doc.id} value={doc.ResourceID}>
                                      {doc.ResourceName}
                                    </option>
                                  ))}
                              </select>
                              <p className="help-block help-block-error"></p>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group field-passporttravelandguardian-visitcountryid required">
                              <label
                                className="control-label"
                                htmlFor="passporttravelandguardian-visitcountryid"
                              >
                                Kazi Yako
                              </label>
                              <select
                                id="VisitCountryID"
                                className="form-control"
                                name="VisitCountryID"
                                onChange={(e) =>
                                  setOccupationID(e.target.value)
                                }
                                value={occupatinID}
                                required
                              >
                                <option value="">Chagua Kazi Yako</option>
                                {ocupations?.length > 0 &&
                                  ocupations?.map((doc) => (
                                    <option key={doc.id} value={doc.ResourceID}>
                                      {doc.ResourceName}
                                    </option>
                                  ))}
                              </select>
                              <p className="help-block help-block-error"></p>
                            </div>
                          </div>
                        </div>
                      </div>
                      {errors && (
                        <div className="help-block help-block-error">
                          {Object.values(errors).map((error, index) => (
                            <p
                              className="help-block help-block-error"
                              key={index}
                            >
                              {error}
                            </p>
                          ))}
                        </div>
                      )}
                    </div>

                    <div className="box-footer">
                      <div className="row">
                        <div className="col-md-4">
                          <Link
                            to="#"
                            className="btn btn-default btn-block btn-label-next"
                            onClick={getAddresInfo}
                          >
                            <i className="fa fa-angle-double-left"></i> | Hatua
                            Iliyotangulia
                          </Link>
                        </div>
                        <div className="col-md-4">
                          <Link
                            onClick={(e) => {
                              e.preventDefault();
                              endeleaBadae();
                            }}
                            className="btn btn-labeled btn-block btn-default"
                          >
                            Endelea Baadae | <i className="fa fa-sign-out"></i>
                          </Link>
                        </div>
                        <div className="col-md-4">
                          <button
                            className="btn btn-default btn-block btn-label-next"
                            name="SaveNext"
                            disabled={isloading}
                          >
                            {isloading ? "Subiri" : "Hifadhi na Endelea |"}
                            <i className="fa fa-angle-double-right"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default HabariZaSafari;
